<button
  class="p-button p-button-icon-only w-auto p-3"
  pButton
  (click)="menu.toggle($event)"
  label=""
>
  <fa-icon class="line-height-1 text-lg" [icon]="icon"></fa-icon>
</button>
<p-menu #menu [popup]="true" [model]="items"></p-menu>
